function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.65,
  fillRule: "evenodd",
  d: "M11.156 4.555H6.68c-.118-.024-.24-.047-.37-.07l-.362-.069c-.6-.117-.963-.234-1.251-.4-.412-.24-.612-.566-.612-.998 0-.433.178-.793.516-1.043.332-.246.806-.376 1.368-.376.643 0 1.138.169 1.475.502a1.485 1.485 0 0 1 .423.825c.01.056.06.096.116.096h.853a.119.119 0 0 0 .118-.118v-.012a2.215 2.215 0 0 0-.723-1.48C7.71.937 6.945.687 6.02.687c-.848 0-1.61.213-2.148.597-.3.216-.532.483-.687.793a2.421 2.421 0 0 0-.238 1.089c0 .346.067.639.203.897.097.183.23.345.4.492H.843a.094.094 0 0 0-.094.093v.704c0 .051.042.093.094.093H5.92l.07.014c.362.073.58.122.78.179.27.076.476.155.647.251.42.237.624.577.624 1.043 0 .414-.181.783-.51 1.041-.358.28-.886.427-1.53.427-.512 0-.946-.1-1.291-.293a1.49 1.49 0 0 1-.731-.92.12.12 0 0 0-.114-.088H2.93a.119.119 0 0 0-.119.118v.012l.008.067c.076.572.355 1.04.828 1.392.552.408 1.329.623 2.248.623.986 0 1.814-.232 2.393-.671.293-.222.518-.495.669-.809a2.46 2.46 0 0 0 .23-1.072c0-.373-.067-.684-.208-.954a1.613 1.613 0 0 0-.255-.36h2.431a.094.094 0 0 0 .094-.095v-.703a.094.094 0 0 0-.094-.092z"
});

var SvgStrikethrough = function SvgStrikethrough(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStrikethrough, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/strikethrough.60c8caa4.svg";
export { ForwardRef as ReactComponent };